import React,{useState} from 'react';
import { Box } from '@material-ui/core';
import CardItem from '../CardItem/CardItem';
import projectData from '../../Data/WebData'



const Portfolio = () => {

    const [projectCart, setProjectCart] = useState(projectData)
    
    return (

            <Box  display="flex" flexWrap="wrap"  justifyContent="center">
                {
                    projectCart.map(pdata => <CardItem key={pdata.id} pdata={pdata}/>)
                } 
            </Box>
    );
};

export default Portfolio;